import api from './api'

// ============================================
// FIELD TEAM API - /field-team
// Team management, live tracking, clients, meetings, targets, reports
// ============================================

// ============================================
// TEAM MANAGEMENT (Admin)
// ============================================
export const getMembers = (params) => api.get('/field-team/admin/members', { params })
export const addMember = (data) => api.post('/field-team/admin/members', data)
export const updateMember = (id, data) => api.put(`/field-team/admin/members/${id}`, data)
export const removeMember = (id) => api.delete(`/field-team/admin/members/${id}`)
export const getAvailableUsers = () => api.get('/field-team/admin/members/available')

// ============================================
// LIVE TRACKING (Admin)
// ============================================
export const getLiveLocations = () => api.get('/field-team/admin/live/locations')
export const getLiveStatus = () => api.get('/field-team/admin/live/status')
export const getMemberRoute = (memberId, date) => api.get(`/field-team/admin/live/member/${memberId}/route`, { params: { date } })
export const getMemberTimeline = (memberId, date) => api.get(`/field-team/admin/live/member/${memberId}/timeline`, { params: { date } })
export const getAllTimelines = (date) => api.get('/field-team/admin/live/timelines', { params: { date } })
export const getRoutes = (params) => api.get('/field-team/admin/routes', { params })

// ============================================
// CLIENTS (Member - own clients)
// ============================================
export const getMyClients = (params) => api.get('/field-team/clients', { params })
export const getMyClient = (id) => api.get(`/field-team/clients/${id}`)
export const createClient = (data) => api.post('/field-team/clients', data)
export const updateClient = (id, data) => api.put(`/field-team/clients/${id}`, data)
export const deleteClient = (id) => api.delete(`/field-team/clients/${id}`)
export const getNearbyClients = (lat, lng, radius) => api.get('/field-team/clients/nearby', { params: { lat, lng, radius } })

// ============================================
// CLIENTS (Admin - all clients)
// ============================================
export const getClients = (params) => api.get('/field-team/admin/clients', { params })
export const getClient = (id) => api.get(`/field-team/admin/clients/${id}`)
export const updateAdminClient = (id, data) => api.put(`/field-team/admin/clients/${id}`, data)
export const deleteAdminClient = (id) => api.delete(`/field-team/admin/clients/${id}`)

// ============================================
// MEETINGS (Member - own meetings)
// ============================================
export const getMyMeetings = (params) => api.get('/field-team/meetings', { params })
export const getMyMeeting = (id) => api.get(`/field-team/meetings/${id}`)
export const createMeeting = (data) => api.post('/field-team/meetings', data)
export const updateMeeting = (id, data) => api.put(`/field-team/meetings/${id}`, data)
export const deleteMeeting = (id) => api.delete(`/field-team/meetings/${id}`)
export const getVoiceMemoUploadUrl = (id) => api.post(`/field-team/meetings/${id}/voice-memo`)
export const completeVoiceMemoUpload = (id, data) => api.put(`/field-team/meetings/${id}/voice-memo-complete`, data)

// ============================================
// MEETINGS (Admin - all meetings)
// ============================================
export const getMeetings = (params) => api.get('/field-team/admin/meetings', { params })
export const getMeeting = (id) => api.get(`/field-team/admin/meetings/${id}`)
export const getMeetingAudioUrl = (id) => api.get(`/field-team/admin/meetings/${id}/audio`)

// ============================================
// TARGETS (Member - own targets)
// ============================================
export const getMyCurrentTargets = () => api.get('/field-team/targets/current')
export const getTodayProgress = () => api.get('/field-team/targets/progress/today')
export const getProgressSummary = (period) => api.get('/field-team/targets/progress/summary', { params: { period } })
export const getTargetHistory = (limit) => api.get('/field-team/targets/history', { params: { limit } })

// ============================================
// TARGETS (Admin)
// ============================================
export const getTargets = (params) => api.get('/field-team/admin/targets', { params })
export const getTarget = (id) => api.get(`/field-team/admin/targets/${id}`)
export const createTarget = (data) => api.post('/field-team/admin/targets', data)
export const updateTarget = (id, data) => api.put(`/field-team/admin/targets/${id}`, data)
export const deleteTarget = (id) => api.delete(`/field-team/admin/targets/${id}`)
export const createBulkTargets = (data) => api.post('/field-team/admin/targets/bulk', data)
export const getTeamTargetOverview = (period_type) => api.get('/field-team/admin/targets/team-overview', { params: { period_type } })

// ============================================
// REPORTS (Admin)
// ============================================
export const getDailyReport = (params) => api.get('/field-team/admin/reports/daily', { params })
export const getWeeklyReport = (params) => api.get('/field-team/admin/reports/weekly', { params })
export const getMemberReport = (memberId, params) => api.get(`/field-team/admin/reports/member/${memberId}`, { params })
export const getReportSummary = (params) => api.get('/field-team/admin/reports/summary', { params })

// ============================================
// INVOICES (Member)
// ============================================
export const getMyInvoices = (params) => api.get('/field-team/invoices', { params })
export const getMyInvoice = (id) => api.get(`/field-team/invoices/${id}`)
export const createInvoice = (data) => api.post('/field-team/invoices', data)
export const updateInvoice = (id, data) => api.put(`/field-team/invoices/${id}`, data)
export const setInvoiceFollowUp = (id, data) => api.put(`/field-team/invoices/${id}/follow-up`, data)
export const getOverdueInvoices = () => api.get('/field-team/invoices/overdue')
export const getDueSoonInvoices = () => api.get('/field-team/invoices/due-soon')

// ============================================
// CLEARANCE (Member)
// ============================================
export const submitClearance = (data) => api.post('/field-team/clearance', data)
export const getMyClearances = (params) => api.get('/field-team/clearance', { params })
export const getMyClearance = (id) => api.get(`/field-team/clearance/${id}`)

// ============================================
// CLEARANCE (Admin)
// ============================================
export const getAllClearances = (params) => api.get('/field-team/admin/clearance', { params })
export const reviewClearance = (id, data) => api.put(`/field-team/admin/clearance/${id}/review`, data)

// ============================================
// COMMISSION (Member)
// ============================================
export const getCommissionSummary = (params) => api.get('/field-team/commission/summary', { params })
export const getCommissionBreakdown = (params) => api.get('/field-team/commission/breakdown', { params })

// ============================================
// COMMISSION (Admin)
// ============================================
export const getCommissionRules = () => api.get('/field-team/admin/commission/rules')
export const saveCommissionRule = (data) => api.post('/field-team/admin/commission/rules', data)
export const deleteCommissionRule = (id) => api.delete(`/field-team/admin/commission/rules/${id}`)
export const getTeamCommission = (params) => api.get('/field-team/admin/commission/team-summary', { params })

// ============================================
// NOTIFICATIONS (Member)
// ============================================
export const getNotifications = (params) => api.get('/field-team/notifications', { params })
export const getUnreadCount = () => api.get('/field-team/notifications/unread-count')
export const markNotificationRead = (id) => api.put(`/field-team/notifications/${id}/read`)
export const markAllNotificationsRead = () => api.put('/field-team/notifications/read-all')
export const deleteNotification = (id) => api.delete(`/field-team/notifications/${id}`)

// ============================================
// HEALTH CHECK
// ============================================
export const checkHealth = () => api.get('/field-team/health')

// ============================================
// COMBINED EXPORT
// ============================================
const fieldTeamApi = {
  // Team
  getMembers,
  addMember,
  updateMember,
  removeMember,
  getAvailableUsers,

  // Live
  getLiveLocations,
  getLiveStatus,
  getMemberRoute,
  getMemberTimeline,
  getAllTimelines,
  getRoutes,

  // Clients (Member)
  getMyClients,
  getMyClient,
  createClient,
  updateClient,
  deleteClient,
  getNearbyClients,

  // Clients (Admin)
  getClients,
  getClient,
  updateAdminClient,
  deleteAdminClient,

  // Meetings (Member)
  getMyMeetings,
  getMyMeeting,
  createMeeting,
  updateMeeting,
  deleteMeeting,
  getVoiceMemoUploadUrl,
  completeVoiceMemoUpload,

  // Meetings (Admin)
  getMeetings,
  getMeeting,
  getMeetingAudioUrl,

  // Targets (Member)
  getMyCurrentTargets,
  getTodayProgress,
  getProgressSummary,
  getTargetHistory,

  // Targets (Admin)
  getTargets,
  getTarget,
  createTarget,
  updateTarget,
  deleteTarget,
  createBulkTargets,
  getTeamTargetOverview,

  // Reports
  getDailyReport,
  getWeeklyReport,
  getMemberReport,
  getReportSummary,

  // Notifications
  getNotifications,
  getUnreadCount,
  markNotificationRead,
  markAllNotificationsRead,
  deleteNotification,

  // Health
  checkHealth
}

export default fieldTeamApi
